import React, { useEffect, useState } from "react";

import {
  Avatar,
  Breadcrumbs as MuiBreadcrumbs,
  Button,
  Card as MuiCard,
  CardActions,
  CardContent as MuiCardContent,
  CardMedia as MuiCardMedia,
  Chip as MuiChip,
  Divider as MuiDivider,
  Grid,
  Link,
  Typography as MuiTypography,
  AvatarGroup as MuiAvatarGroup,
} from "@mui/material";
import { LazyLoadImage } from "react-lazy-load-image-component";
import styled from "@emotion/styled";
import { spacing } from "@mui/system";
import axios from "axios";
import GalleryImgDelBtn from "./GalleryImgDelBtn";

// ----------------------------------------------------------------------
const Card = styled(MuiCard)(spacing);

const CardContent = styled(MuiCardContent)`
  border-bottom: 1px solid ${(props) => props.theme.palette.grey[300]};
`;

const CardMedia = styled(MuiCardMedia)`
  height: 220px;
`;
const Typography = styled(MuiTypography)(spacing);

export default function GalleryImg({ editData, onComplete }) {
  if (!editData) return <></>;
  if (!editData.galleryimg) return <></>;
  return (
    <Grid container spacing={6} columns={{ xs: 4, sm: 8, md: 12 }}>
      {editData.galleryimg.map((item, i) => (
        <>
          {item && (
            <Grid item xs={2} sm={4} md={4} key={i}>
              <ImgFromUrl
                image={item}
                editData={editData}
                onComplete={onComplete}
              />
            </Grid>
          )}
        </>
      ))}
    </Grid>
  );
}
const ImgFromUrl = ({ image, editData, onComplete }) => {
  const [imageObj, setimageObj] = useState(null);
  useEffect(() => {
    return () => {
      setimageObj(null);
    };
  }, []);

  useEffect(() => {
    if (!image) return;
    const init = async () => {
      try {
        const response = await axios.get(`${image}`, {
          responseType: "arraybuffer",
        });
        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });

        const imageDataUrl = URL.createObjectURL(blob);
        setimageObj(imageDataUrl);
      } catch (error) {
        console.error(error);
      }
    };
    init();
  }, [image]);

  useEffect(() => {
    return () => {
      setimageObj(null);
    };
  }, []);
  return (
    <Card>
      <LazyLoadImage
        alt=""
        src={imageObj} // use normal <img> attributes as props
        width="100%"
      />
      <CardActions sx={{ display: "flex", justifyContent: "flex-end" }}>
        <GalleryImgDelBtn
          editData={editData}
          image={image}
          onComplete={onComplete}
        />
      </CardActions>
    </Card>
  );
};
